/**
 * The one button that opens the AI read.
 *
 * It appears on seven screens and looks identical on all of them, which is
 * the point: nobody should have to work out where the AI lives on the deals
 * page having already found it on the pipeline. It knows nothing about what
 * it is reading — it names a module and an id and the panel does the rest.
 *
 * It hides itself when AI is switched off in Settings rather than showing a
 * button that explains it cannot work. A control that is never going to do
 * anything is worse than no control.
 */
import { useApp } from '../store/AppContext.jsx';
import Icon from '../lib/icons.jsx';

export default function AskAI({
  module, id, subject, label = 'Ask AI', ghost, sm, className = ''
}) {
  const { S, setSheet } = useApp();
  if (S && S.aiOn === false) return null;

  return (
    <button
      type="button"
      className={`aibtn${ghost ? ' ghost' : ''}${sm ? ' sm' : ''}${className ? ` ${className}` : ''}`}
      title="Read this record and say what to do"
      onClick={e => {
        /* These sit inside rows that open their own panel on click. */
        e.stopPropagation();
        setSheet({ kind: 'aiInsight', module, id, subject });
      }}
    >
      <Icon name="wand" />{label}
    </button>
  );
}
